// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/lock.js';

import { paths } from '../generated/lock';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('lock', Original, paths);
